// Shows a pin on the map on search results.
import React from 'react';
import { useSelector } from 'react-redux';

import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { getDefaultMarkerPosition } from '@selectors/map-selector';

const SearchMarker = () => {
  const defaultMarkerPosition = useSelector(getDefaultMarkerPosition);
  if (defaultMarkerPosition) {
    return <AdvancedMarker position={defaultMarkerPosition} zIndex={250} />;
  }
  return null;
};

export default SearchMarker;
